import { render, staticRenderFns } from "./SolutionAccessModal.vue?vue&type=template&id=4b777162&scoped=true&"
import script from "./SolutionAccessModal.vue?vue&type=script&lang=ts&"
export * from "./SolutionAccessModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b777162",
  null
  
)

export default component.exports